import {CanActivateFn} from '@angular/router';
import {Inject} from "@angular/core";
import {ApiAuthService} from "@core/services/api/api-auth.service";

export const roleGuard: CanActivateFn = (route, state): boolean => {
  Inject(ApiAuthService)
  const requiredRoles = route.data['roles'] // Required roles for this route
  const rolesString = JSON.parse(localStorage.getItem('ROLE')!);
  return JSON.parse(rolesString) === requiredRoles;
};
